





































































































import {
  computed, ref, ComputedRef, defineComponent,
} from '@vue/composition-api';
import { DonutProgressProps } from './types';

interface DonutProgressBinding {
  isGradient: ComputedRef<boolean>;
  isCompleted: ComputedRef<boolean>;
  gradientId: ComputedRef<string>;
  gradientOffset: ComputedRef<(index: number) => number>;
  strokeColor: ComputedRef<string>;
  foregroundColor: ComputedRef<string>;
  ringDashArray: ComputedRef<string>;
  ringDashOffset: ComputedRef<number>;
}

export default defineComponent<DonutProgressProps, DonutProgressBinding>({
  name: 'DonutProgress',
  props: {
    color: {
      type: [String, Array],
      required: true,
    },
    backgroundColor: {
      type: String,
      required: true,
    },
    numerator: {
      type: Number,
      required: true,
    },
    denominator: {
      type: Number,
      required: true,
    },
    ringThickness: {
      type: Number,
      default: 10,
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    ringLinecap: {
      type: String,
      default: 'butt',
    },
    valueFormatter: {
      type: Function,
      default: undefined,
    },
  },
  setup(props) {
    const isGradient = computed<boolean>(() => Array.isArray(props.color));
    const isCompleted = computed<boolean>(() => props.numerator === props.denominator);
    const foregroundColor = computed<string>(() => (isGradient.value
      ? (props.color as string[])[0]
      : props.color as string));
    const seed = ref<number>(Math.random());
    const gradientId = computed<string>(() => `gradient-id-${seed.value}`);
    const percent = computed<number>(() => props.numerator / props.denominator * 100);

    return {
      isGradient,
      isCompleted,
      foregroundColor,
      gradientId,
      gradientOffset: computed<(index: number) => number>(
        () => (index: number) => index / (props.color.length - 1)),
      strokeColor: computed<string>(() => ((isGradient.value && !isCompleted.value) ? `url(#${gradientId.value})` : foregroundColor.value)),
      ringDashArray: computed<string>(() => `${percent.value} ${100 - percent.value}`),
      ringDashOffset: computed<number>(() => percent.value + 25),
    };
  },
});
